export default __webpack_public_path__ + "static/media/PersonFill.a0de3d12.svg";